import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { withMobile } from 'utils/mobile'

import ProductsContent from '../ProductsContent'
import LoadingProductsSkeleton from '../LoadingProductsSkeleton'

import { homeErrorSelector, homeLoadingSelector } from 'store/selectors/home'
import ProductListItem from './ProductListItem'

export const ProductsList = ({ main, error, loading, onRetry, mobile }) => {
    return (
        <ProductsContent
            onRetry={onRetry}
            error={error}
            loading={loading}
            mobile={mobile}
            main={main}
        >
            {loading || error ? (
                <LoadingProductsSkeleton
                    key={0}
                    active={loading}
                    mobile={mobile}
                />
            ) : (
                <ProductListItem main={main} />
            )}
        </ProductsContent>
    )
}

const mapStateToProps = (state) => ({
    loading: homeLoadingSelector(state),
    error: homeErrorSelector(state)
})

export default withMobile(withRouter(connect(mapStateToProps)(ProductsList)))
